import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import useQueries from '../../../../database/useQueries';
import FormTemplate from '../../../template/form/FormTemplate';
import CommponentOptions from '../../plagins/data/commponentOptions';
import { format, parseISO } from 'date-fns';
import { DataContext } from '../../pagesMains/GravesManagers/Graves';

function ReportDialog({ setCategory = () => { } }) {
  // קבלת ערכים מהסטור
  const columns = useSelector((state) => state.columnsFormReports.data);
  const context = useContext(DataContext);

  // טעינת היוזים לפונקציות עזר
  const { getEntityByAttr, getEntitiesByAttr } = useQueries();

  // ערכי הראוטר
  const location = useLocation()
  const { value } = location.state || {};

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setloadingData] = useState(false);

  // משתנים לערכי סלקט של השדות
  const [cemeteries, setCemeteries] = useState([])
  const [blocks, setBlocks] = useState([])
  const [plots, setPlots] = useState([])

  // פונקציה לטעינת השדות מתוך הסטור
  const myColumns = (localColumns = null) => {
    localColumns = localColumns !== null ? localColumns : columns
    return localColumns.map((field, index) => {
      // let lock = false
      // lock = (
      //   field.name === 'cemeteryId' || field.name === 'blockId' || field.name === 'plotId'
      // ) ? true : false
      return ({
        ...field,
        // disabled: lock ? lock : field.disabled,
        required: (field.name === 'spouse' && formValues.maritalStatus === 2) ? true : (field.required || false),
        show: field?.show || false,
      })
    });
  };

  // // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => { handleAllDataLoaded() }, [context]);

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    const initialFormValues = myColumns().reduce((acc, field) => {
      let fieldValue = '';
      if (field.name === 'cemeteryId' || field.name === 'blockId' || field.name === 'plotId') {
        fieldValue = -1
      }
      if (field.input === 'date') {
        if (field.name === 'startDate') {
          const currentYear = new Date().getFullYear();
          fieldValue = format(new Date(currentYear, 0, 1), 'yyyy-MM-dd'); // תחילת השנה הנוכחית
        } else if (field.name === 'endDate') {
          fieldValue = format(new Date(), 'yyyy-MM-dd'); // התאריך הנוכחי
        }
      }


      return {
        ...acc,
        [field.name]: fieldValue,
      };
    }, {});

    setFieldsWithDynamicDisabled(myColumns());
    setFormValues(initialFormValues);
    fieldAuto();
  };


  // // טעינת ערכים אוטומטית לשדות
  const fieldAuto = () => {
    setCemeteries(
      [
        CommponentOptions({ value: '', label: '' }),
        ...context?.contextCemeteries?.map(cemetery => CommponentOptions({ value: cemetery?.unicId, label: cemetery?.cemeteryNameHe }))
      ]
    )
    setBlocks(
      [
        CommponentOptions({ value: '', label: '' }),
        ...context?.contextBlocks?.map(block => {
          const cemetery = context?.contextCemeteries?.find(cemetery => cemetery?.unicId === block?.cemeteryId)
          return CommponentOptions({
            value: block?.unicId, label: block?.blockNameHe, dataUnderRigth: {
              title: 'בית עלמין: ',
              value: cemetery?.cemeteryNameHe
            }
          })
        })
      ]
    )
    setPlots(
      [
        CommponentOptions({ value: '', label: '' }),
        ...context?.contextPlots?.map(plot => {
          const block = context?.contextBlocks?.find(block => block?.unicId === plot?.blockId)
          const cemetery = context?.contextCemeteries?.find(cemetery => cemetery?.unicId === block?.cemeteryId)
          return CommponentOptions({
            value: plot?.unicId, label: plot?.plotNameHe,
            dataUnderRigth: { title: 'גושים: ', value: block?.blockNameHe },
            dataUnderLeft: { title: 'בית עלמין: ', value: cemetery?.cemeteryNameHe },
          })
        })
      ]
    )
  }

  const fieldChangeCemeteryId = (event, newFormValues) => {
    let blocks = context?.contextBlocks
    let plots = context?.contextPlots
    let res = {}
    if (event.target.value !== -1 && event.target.value !== '') {
      delete newFormValues?.blockId;
      delete newFormValues?.plotId;
      delete newFormValues?.lineId;
      blocks = getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', event.target.value)
      plots = context?.contextPlots?.filter(plot =>
        blocks?.some(block => block?.unicId === plot.blockId)
      )
      res = { plotId: -1, blockId: -1, cemeteryId: event.target.value }
    }
    else {
      res = { plotId: -1, blockId: -1, cemeteryId: -1 }
    }
    setBlocks(
      [
        CommponentOptions({ value: '', label: '' }),
        ...blocks?.map(block => {
          const cemetery = context?.contextCemeteries?.find(cemetery => cemetery?.unicId === block?.cemeteryId)
          return CommponentOptions({
            value: block?.unicId, label: block?.blockNameHe, dataUnderRigth: {
              title: 'בית עלמין: ',
              value: cemetery?.cemeteryNameHe
            }
          })
        })
      ]
    )
    setPlots(
      [
        CommponentOptions({ value: '', label: '' }),
        ...plots?.map(plot => {
          const block = context?.contextBlocks?.find(block => block?.unicId === plot?.blockId)
          const cemetery = context?.contextCemeteries?.find(cemetery => cemetery?.unicId === block?.cemeteryId)
          return CommponentOptions({
            value: plot?.unicId, label: plot?.plotNameHe,
            dataUnderRigth: { title: 'גוש: ', value: block?.blockNameHe },
            dataUnderLeft: { title: 'בית עלמין: ', value: cemetery?.cemeteryNameHe },
          })
        })
      ]
    )
    return res
  }
  const fieldChangeBlockId = (event, newFormValues) => {
    let res = {}
    if (event.target.value !== -1 && event.target.value !== '') {
      delete newFormValues?.plotId;
      delete newFormValues?.lineId;

      const block = getEntityByAttr(context?.contextBlocks, 'unicId', event.target.value)
      const cemetery = getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId)

      const plots = getEntitiesByAttr(context?.contextPlots, 'blockId', event.target.value)

      setPlots(
        [
          CommponentOptions({ value: '', label: '' }),
          ...plots?.map(plot => {
            const block = context?.contextBlocks?.find(block => block?.unicId === plot?.blockId)
            const cemetery = context?.contextCemeteries?.find(cemetery => cemetery?.unicId === block?.cemeteryId)
            return CommponentOptions({
              value: plot?.unicId, label: plot?.plotNameHe,
              dataUnderRigth: { title: 'גוש: ', value: block?.blockNameHe },
              dataUnderLeft: { title: 'בית עלמין: ', value: cemetery?.cemeteryNameHe },
            })
          })
        ]
      )
      res = { cemeteryId: cemetery?.unicId, blockId: event.target.value, plotId: -1 }
    }
    else {
      res = { ...res, plotId: -1, blockId: -1 }
    }
    return res
  }
  const fieldChangePlotId = (event, newFormValues) => {
    let res = {}
    if (event.target.value !== -1 && event.target.value !== '') {
      delete newFormValues?.lineId;

      const plot = getEntityByAttr(context?.contextPlots, 'unicId', event.target.value)
      const block = getEntityByAttr(context?.contextBlocks, 'unicId', plot?.blockId)
      const cemetery = getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId)

      res = { plotId: plot?.unicId, blockId: block?.unicId, cemeteryId: cemetery?.unicId }
    }
    return res
  }
  const handleChange = (event) => {

    let newFormValues = formValues
    let value = event.target.value
    if (event.target.name === 'cemeteryId') {
      const res = fieldChangeCemeteryId(event, newFormValues)
      newFormValues = { ...newFormValues, ...res }
    }
    if (event?.target?.name === 'blockId') {
      const res = fieldChangeBlockId(event, newFormValues)
      newFormValues = { ...newFormValues, ...res }
    }
    if (event?.target?.name === 'plotId') {
      const res = fieldChangePlotId(event, newFormValues)
      newFormValues = { ...newFormValues, ...res }
    }
    if (event?.target?.name === 'startDate' || event?.target?.name === 'endDate') {
      try {
        const parsedDate = parseISO(event.target.value);
        if (!isNaN(parsedDate.getTime())) {
          newFormValues = { ...newFormValues, [event.target.name]: format(parsedDate, 'yyyy-MM-dd') };
        // } else {
        //   console.error('Invalid date:', event.target.value);
        }
      } catch (error) {
        // console.error('Error parsing date:', error);
      }
    } else {
      newFormValues = { ...newFormValues, [event.target.name]: value };
    }

    setFormValues(newFormValues)

    if (validateForm(newFormValues)) {
      // console.log(newFormValues);


      const cemetery = newFormValues?.cemeteryId !== -1 ?
        getEntityByAttr(context?.contextCemeteries, 'unicId', newFormValues?.cemeteryId) : null
      const block = newFormValues?.blockId !== -1 ?
        getEntityByAttr(context?.contextBlocks, 'unicId', newFormValues?.blockId) : null
      const plot = newFormValues?.plotId !== -1 ?
        getEntityByAttr(context?.contextPlots, 'unicId', newFormValues?.plotId) : null
      const startDate = newFormValues?.startDate !== '' ? newFormValues?.startDate : new Date()
      const endDate = newFormValues?.endDate !== '' ? newFormValues?.endDate : new Date()

      const cemeteries = cemetery ? [cemetery] : context?.contextCemeteries
      const blocks = block ? [block] : context?.contextBlocks
        .filter(localBlock => cemeteries.some(block => block?.unicId === localBlock.cemeteryId));
      const plots = plot ? [plot] : context?.contextPlots
        .filter(localPlot => blocks.some(plot => plot?.unicId === localPlot.blockId));
      const areaGraves = context?.contextAreaGraves
        .filter(localAreaGrave => plots.some(areaGrave => areaGrave?.unicId === localAreaGrave.plotId));
      const graves = context?.contextGraves
        .filter(localGrave => areaGraves.some(grave => grave.unicId === localGrave.areaGraveId));

      setCategory({
        areaGraves, graves, startDate, endDate
      })

    }
  }

  const validateForm = (newFormValues) => {
    let tempErrors = {};
    let formIsValid = true;

    columns.forEach(field => {
      if (field.required && !newFormValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };

  return (
    <>
      <FormTemplate
        // titleMin={`קריטריונים לדו״ח`}
        local={true}
        noCard

        fields={fieldsWithDynamicDisabled}
        columns={columns}
        formValues={{ ...formValues }}

        handleChange={handleChange}
        options={{
          cemeteryId: cemeteries,
          blockId: blocks,
          plotId: plots,
        }}
        errors={errors}
        noClearable
      />
    </>
  )
}

export default ReportDialog;
